export const createListReducer = templateName => {
  const initialState = () => ({
    error: null,
    loading: false,
    isFirstLoad: true,
    isFetchingMore: false,
    isSearching: false,
    isFiltering: false,
    loadedData: []
  });

  return (state = initialState(), action) => {
    switch (action.type) {
      case `${templateName}_PENDING`: {
        return {
          ...state,
          error: state.error,
          loading: true,
          isFirstLoad: state.isFirstLoad
        };
      }

      case `${templateName}_REJECTED`: {
        return {
          ...state,
          error: action.payload.error,
          loading: false,
          isFirstLoad: false
        };
      }

      case `${templateName}_FULFILLED`: {
        const newData = action.payload;
        return {
          ...state,
          loading: false,
          isFirstLoad: false,
          loadedData: newData
        };
      }

      case `${templateName}_PERPAGE_PENDING`: {
        return {
          ...state,
          loading: true,
          isFetchingMore: true
        };
      }

      case `${templateName}_PERPAGE_REJECTED`: {
        return {
          ...state,
          error: action.payload.error,
          loading: false,
          isFetchingMore: false
        };
      }

      case `${templateName}_PERPAGE_FULFILLED`: {
        const currentData = state.loadedData;
        const newData = action.payload;

        return {
          ...state,
          loading: false,
          isFetchingMore: false,
          loadedData: [...currentData, ...newData]
        };
      }

      case `${templateName}_SEARCH_PENDING`: {
        return {
          ...state,
          loading: true,
          isSearching: true
        };
      }

      case `${templateName}_SEARCH_REJECTED`: {
        return {
          ...state,
          error: action.payload.error,
          loading: false,
          isSearching: false
        };
      }

      case `${templateName}_SEARCH_FULFILLED`: {
        const newData = action.payload;

        return {
          ...state,
          loading: false,
          isSearching: false,
          loadedData: newData
        };
      }

      case `${templateName}_FILTER_PENDING`: {
        return {
          ...state,
          error: state.error,
          loading: true,
          isFiltering: true
        };
      }

      case `${templateName}_FILTER_REJECTED`: {
        return {
          ...state,
          error: action.payload.error,
          loading: false,
          isFiltering: false
        };
      }

      case `${templateName}_FILTER_FULFILLED`: {
        const newData = action.payload;

        return {
          ...state,
          loading: false,
          isFiltering: false,
          loadedData: newData
        };
      }

      case `${templateName}_ADD_IN_LIST_PENDING`: {
        return {
          ...state,
          loading: true
        };
      }
      case `${templateName}_ADD_IN_LIST_REJECTED`: {
        return {
          ...state,
          error: action.payload.error,
          loading: false
        };
      }
      case `${templateName}_ADD_IN_LIST_FULFILLED`: {
        const newData = action.payload;
        const currentList = [...state.loadedData];
        const newList = [newData, ...currentList];

        return {
          ...state,
          loading: false,
          loadedData: [...newList]
        };
      }

      case `${templateName}_REPLACE_IN_LIST_PENDING`: {
        return {
          ...state,
          loading: true
        };
      }
      case `${templateName}_REPLACE_IN_LIST_REJECTED`: {
        return {
          ...state,
          error: action.payload,
          loading: false
        };
      }
      case `${templateName}_REPLACE_IN_LIST_FULFILLED`: {
        const editedData = action.payload;
        const currentList = [...state.loadedData];
        const newList = currentList.map(item => (item.id === editedData.id ? editedData : item));

        return {
          ...state,
          loading: false,
          loadedData: [...newList]
        };
      }

      case `${templateName}_REMOVE_FROM_LIST_PENDING`: {
        const deactivatedVisit = action.payload;
        const currentList = [...state.loadedData];
        const newList = currentList.filter(item => item.id !== deactivatedVisit.id);

        return {
          ...state,
          loading: false,
          isFiltering: false,
          loadedData: [...newList]
        };
      }
      case `${templateName}_REMOVE_FROM_LIST_REJECTED`: {
        return {
          ...state,
          error: action.payload.error,
          loading: false
        };
      }
      case `${templateName}_REMOVE_FROM_LIST_FULFILLED`: {
        const deactivatedVisit = action.payload;
        const currentList = [...state.loadedData];
        const newList = currentList.filter(item => item.id !== deactivatedVisit.id);

        return {
          ...state,
          loading: false,
          loadedData: [...newList]
        };
      }

      case `${templateName}_RESET`: {
        return initialState();
      }

      default:
        return state;
    }
  };
};
